import React from 'react';
import { FiMessageCircle } from 'react-icons/fi';

const testimonialData = [
    { image: 'testimonial-04', name: 'Piotr', designation: 'Opinia na Facebooku', description: 'Nowe łodzie, profesjonalna obsługa, idealne miejsce do wypożyczenia motorówki na dzień ze znajomymi w Augustowie.' },
    { image: 'testimonial-02', name: 'm.pamela.91', designation: 'Komentarz na Instagramie', description: 'Bardzo dziękujemy za wspaniały weekend na augustowskich jeziorach. Szczerze was polecam!' },
    { image: 'testimonial-03', name: 'Marta Rubczewska', designation: 'Opinia Google', description: 'Wszystko bezproblemowo, eleganckie i nowoczesne motorówki. Skorzystamy jeszcze nie raz.' },
    { image: 'testimonial-05', name: 'Sylwia Z.', designation: 'Opinia Google', description: 'Super obsługa, łodzie w idealnym stanie, rezerwacja online działa bez zarzutu. Polecam każdemu!' },
    { image: 'testimonial-06', name: 'Anna Pietrzak', designation: 'Opinia na Facebooku', description: 'Najlepszy wynajem motorówek w Augustowie. Jezioro Białe i Necko zwiedziliśmy komfortowo i bezpiecznie.' },
    { image: 'testimonial-01', name: 'Bartek K.', designation: 'Opinia Google', description: 'Fantastyczna przygoda, polecam każdemu kto szuka motorówki na wynajem w Augustowie.' },
];

const TestimonialOne = () => (
    <div className="blackwave-reviews" aria-label="Opinie klientów BlackWave">
        {testimonialData.map((review) => (
            <figure className="blackwave-review" key={`${review.name}-${review.designation}`}>
                <FiMessageCircle className="blackwave-review__quote" aria-hidden="true" />
                <blockquote>
                    <p>„{review.description}”</p>
                </blockquote>
                <figcaption className="blackwave-review__author">
                    <img
                        src={`${process.env.PUBLIC_URL}/images/testimonial/${review.image}.jpg`}
                        alt=""
                        width="56"
                        height="56"
                        loading="lazy"
                        decoding="async"
                    />
                    <span>
                        <strong>{review.name}</strong>
                        <small>{review.designation}</small>
                    </span>
                </figcaption>
            </figure>
        ))}
    </div>
);

export default TestimonialOne;
